import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Weddingluxurycabrentals() {



  const cardData =
  {
    keyword: 'Wedding Luxury Cab Rentals in Bangalore',
    heading: 'Aaryan Travels: Wedding Luxury Cab Rentals in Bangalore',
    headingDescription: 'Aaryan Travels offers premium Wedding Luxury Cab Rentals in Bangalore to make your special day grand and well-coordinated. Whether you need a luxury sedan for the groom’s entry, a high-end SUV for family transport, or a convoy of premium cabs for guests, our fleet—including Mercedes, BMW, and Innova Crysta—ensures style and comfort. We also provide decorated bridal cars with uniformed chauffeurs for traditional or modern wedding themes. From Koramangala to Whitefield, Electronic City to Hebbal, Aaryan Travels delivers punctual and classy luxury cab services for weddings, receptions, and engagement events across Bangalore.',

    top: 'Top Places to Visit in Bangalore with Aaryan Travels',

"topPlaces": [
  {
    "title": "Lalbagh Botanical Garden",
    "description": "Lalbagh Botanical Garden is a 240-acre green sanctuary in the heart of Bangalore, known for its rare plant species and serene lakes. The iconic Glass House, inspired by London’s Crystal Palace, hosts colorful flower shows every year. Early mornings here are filled with joggers, bird watchers, and nature lovers. The centuries-old trees and peaceful walking trails offer a refreshing escape. Lalbagh is Bangalore’s timeless retreat of beauty and tranquility."
  },
  {
    "title": "Bangalore Palace",
    "description": "Bangalore Palace, built in 1878, resembles a European castle with its Tudor-style architecture, turrets, and wooden interiors. Visitors can explore grand halls adorned with royal portraits and vintage furniture. The palace grounds often host concerts and cultural events. Its regal charm reflects the luxury of the Wodeyar dynasty. Bangalore Palace is the city’s majestic symbol of heritage and elegance."
  },
  {
    "title": "Cubbon Park",
    "description": "Cubbon Park spans over 300 acres of lush greenery, making it a favorite spot for walkers, cyclists, and families. Lined with bamboo groves, flowering trees, and colonial-era statues, it offers scenic walking paths. Children enjoy the toy train rides within the park. Nearby landmarks like the State Central Library add to its charm. Cubbon Park is Bangalore’s peaceful urban lungs."
  },
  {
    "title": "ISKCON Temple",
    "description": "ISKCON Temple in Rajajinagar is one of the largest Krishna temples in the world, built with white marble and intricate carvings. The temple complex hosts devotional music, spiritual talks, and prasadam distribution. Visitors can also enjoy museum exhibits on Lord Krishna’s life. The hilltop setting offers stunning city views. ISKCON is Bangalore’s serene sanctuary of devotion."
  },
  {
    "title": "Nandi Hills",
    "description": "Situated about 60 km from the city, Nandi Hills is a popular sunrise destination offering breathtaking views of the clouds and valleys below. Once a summer retreat of Tipu Sultan, it still houses ancient fort walls and viewpoints. Adventure seekers enjoy trekking and cycling up the hill. The cool breeze and misty ambiance make mornings unforgettable. Nandi Hills is Bangalore’s scenic escape into the clouds."
  },
  {
    "title": "Vidhana Soudha",
    "description": "Vidhana Soudha is a massive government building and the seat of Karnataka’s legislature. Built in Neo-Dravidian architectural style, it features imposing granite pillars and domed roofs. The building is beautifully illuminated on Sunday evenings. It stands as a grand representation of governance and architectural excellence. Vidhana Soudha is Bangalore’s proud monument of authority."
  },
  {
    "title": "Bannerghatta Biological Park",
    "description": "Bannerghatta Biological Park offers thrilling jeep safaris where visitors can watch tigers, lions, and elephants in their natural habitats. The park also features a butterfly garden, reptile enclosures, and a zoo. It’s perfect for educational trips and family outings. Surrounded by dense forest, it feels like a true wildlife adventure. Bannerghatta is Bangalore’s exciting encounter with nature."
  },
  {
    "title": "Commercial Street",
    "description": "Commercial Street is Bangalore’s most popular shopping district known for trendy fashion stores, footwear lanes, and budget accessories. The narrow streets are always bustling with shoppers and bargain hunters. Street food vendors add to the lively atmosphere. From ethnic wear to street style, it has everything at affordable prices. Commercial Street is Bangalore’s buzzing hub of shopping and fun."
  },
  {
    "title": "UB City",
    "description": "UB City is a luxury commercial complex featuring global brand outlets, fine dining restaurants, and rooftop lounges. Its open-air plaza often hosts live music, events, and art displays. People visit for premium shopping and social gatherings. The modern glass architecture adds to its appeal. UB City is Bangalore’s glamorous face of sophistication."
  },
  {
    "title": "MG Road and Brigade Road",
    "description": "MG Road and Brigade Road are iconic stretches famous for their nightlife, cafes, bookstores, and retail outlets. These streets are always filled with energy and excitement. During festivals, the entire stretch lights up beautifully. It’s a favorite hangout spot for youngsters and tourists. MG Road is Bangalore’s lively heartbeat of urban life."
  }
],



"services": [
  {
    "name": "Wedding Luxury Cab Rentals in Bangalore",
    "description": "Wedding Luxury Cab Rentals in Bangalore provide elegant and sophisticated vehicles tailored specifically for wedding ceremonies and related events. These premium cabs ensure a memorable and stylish arrival or departure with professional chauffeurs who understand the significance of the occasion, delivering impeccable service and punctuality throughout the wedding day."
  },
  {
    "name": "Bridal Cab Hire Bangalore",
    "description": "Bridal Cab Hire Bangalore specializes in providing luxurious and comfortable transportation for brides. The service focuses on creating a seamless and graceful experience, with exquisitely maintained cars and courteous chauffeurs trained to handle wedding day logistics with utmost care and professionalism."
  },
  {
    "name": "Luxury Wedding Car Bangalore",
    "description": "Luxury Wedding Car Bangalore offers a fleet of high-end vehicles perfect for wedding events. From plush sedans to stylish SUVs, these cars combine elegance with comfort, allowing the bridal party and guests to travel in ultimate style and luxury on this special day."
  },
  {
    "name": "Chauffeur Driven Wedding Vehicle Bangalore",
    "description": "Chauffeur Driven Wedding Vehicle Bangalore delivers premium chauffeured cars for weddings, ensuring timely pick-ups and drop-offs with a touch of sophistication. Drivers are experienced in wedding protocols and maintain a discreet yet attentive service, enhancing the overall wedding experience."
  },
  {
    "name": "Premium Wedding Taxi Bangalore",
    "description": "Premium Wedding Taxi Bangalore provides exclusive taxi services with luxurious vehicles, ideal for weddings and receptions. The service combines comfort, style, and reliability to ensure that all wedding transportation needs are met with a high standard of excellence."
  },
  {
    "name": "Classic Car for Wedding Bangalore",
    "description": "Classic Car for Wedding Bangalore offers vintage and classic cars that add a timeless charm to any wedding. These iconic vehicles create a unique and nostalgic atmosphere, perfect for couples looking for a traditional yet elegant transportation option."
  },
  {
    "name": "Executive Wedding Transport Bangalore",
    "description": "Executive Wedding Transport Bangalore caters to those seeking sophisticated and executive-class vehicles for wedding transportation. This service is ideal for business professionals and VIP guests attending weddings, providing luxury combined with discretion and punctuality."
  },
  {
    "name": "Affordable Wedding Cab Bangalore",
    "description": "Affordable Wedding Cab Bangalore provides budget-friendly luxury transportation options for weddings. Without compromising on quality or comfort, this service ensures that brides, grooms, and guests can enjoy stylish rides that fit within their wedding budget."
  },
  {
    "name": "Wedding SUV/Sedan Rental Bangalore",
    "description": "Wedding SUV/Sedan Rental Bangalore offers a variety of spacious SUVs and elegant sedans tailored for wedding events. Whether transporting the bridal party or family members, these vehicles provide comfort, style, and ample space for a smooth wedding day experience."
  },
  {
    "name": "Elite Wedding Cab Bangalore",
    "description": "Elite Wedding Cab Bangalore provides top-tier luxury cars and professional chauffeurs dedicated to delivering a first-class experience for weddings. This service ensures that every ride exudes prestige and grace, perfectly complementing the grandeur of the occasion."
  },
  {
    "name": "High-End Wedding Car Bangalore",
    "description": "High-End Wedding Car Bangalore offers premium and exotic vehicles for weddings, designed to impress and provide maximum comfort. With a focus on luxury and style, these cars help make the wedding day truly unforgettable for couples and guests alike."
  },
  {
    "name": "Best Wedding Chauffeur Bangalore",
    "description": "Best Wedding Chauffeur Bangalore prides itself on providing skilled and courteous drivers trained specifically for wedding services. These chauffeurs ensure smooth, timely transportation with utmost respect for wedding customs and the special needs of the bridal party."
  },
  {
    "name": "Wedding Event Cab Bangalore",
    "description": "Wedding Event Cab Bangalore manages transportation logistics for entire wedding events, including guest transfers, venue pickups, and drop-offs. This comprehensive service guarantees coordination and reliability, allowing families to focus on celebrations without transportation concerns."
  },
  {
    "name": "Bangalore Wedding Car Booking",
    "description": "Bangalore Wedding Car Booking simplifies the process of reserving luxury wedding vehicles through an easy-to-use online platform. Clients can browse options, compare services, and book their preferred wedding cars with confidence and convenience."
  },
  {
    "name": "Prestige Wedding Cabs Bangalore",
    "description": "Prestige Wedding Cabs Bangalore offers exclusive luxury cars and premium services designed to add a touch of elegance and prestige to any wedding. With attention to detail and personalized service, this provider ensures a flawless transportation experience on the big day."
  }
],
"tableData": [
  ["Wedding Luxury Cab Rentals in Bangalore", "Bridal Cab Hire Bangalore"],
  ["Luxury Wedding Car Bangalore", "Chauffeur Driven Wedding Vehicle Bangalore"],
  ["Premium Wedding Taxi Bangalore", "Classic Car for Wedding Bangalore"],
  ["Executive Wedding Transport Bangalore", "Affordable Wedding Cab Bangalore"],
  ["Wedding SUV/Sedan Rental Bangalore", "Elite Wedding Cab Bangalore"],
  ["High-End Wedding Car Bangalore", "Best Wedding Chauffeur Bangalore"],
  ["Wedding Event Cab Bangalore", "Bangalore Wedding Car Booking"],
  ["Prestige Wedding Cabs Bangalore", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Wedding Luxury Cab Rentals in Bangalore",
    "WhyChoosedescription": "Aaryan Travels provides elegant wedding luxury cab rentals in Bangalore, ensuring your special day is stylish and comfortable."
  },
  {
    "WhyChooseheading": "Premium Fleet of Luxury Vehicles",
    "WhyChoosedescription": "Choose from our selection of top-tier luxury cars perfect for weddings, receptions, and related celebrations."
  },
  {
    "WhyChooseheading": "Professional and Courteous Chauffeurs",
    "WhyChoosedescription": "Our experienced drivers offer punctual, respectful, and seamless service tailored to wedding occasions."
  },
  {
    "WhyChooseheading": "Vehicle Decoration Services Available",
    "WhyChoosedescription": "Enhance your wedding experience with our customizable cab decoration options."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for hassle-free budgeting."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings and last-minute changes."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Select hourly, daily, or customized plans to perfectly suit your wedding transportation needs."
  },
  {
    "WhyChooseheading": "Reliable and Timely Service on Your Wedding Day",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs, making your wedding events run smoothly without transportation hassles."
  }
]
















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer wedding luxury cab rentals in Bangalore?',
    answer: 'Yes, Aaryan Travels provides elegant wedding luxury cab rentals in Bangalore to make your special day memorable and stylish.',
  },
  {
    question: 'How can I book wedding luxury cab rentals in Bangalore with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team in Bangalore.',
  },
  {
    question: 'What types of luxury vehicles are available for wedding rentals in Bangalore?',
    answer: 'Aaryan Travels offers a selection of premium luxury cars including Mercedes, BMW, and Audi perfect for weddings in Bangalore.',
  },
  {
    question: 'Are drivers trained and experienced for wedding luxury cab rentals in Bangalore?',
    answer: 'Absolutely. Our drivers are professionally trained, punctual, and respectful to ensure a smooth and grand wedding experience.',
  },
  {
    question: 'Can wedding luxury cab rentals in Bangalore be customized for different wedding events?',
    answer: 'Yes, you can book luxury cabs for all wedding-related events such as the ceremony, reception, and guest transportation in Bangalore.',
  },
  {
    question: 'Is the wedding luxury cab rental service available 24x7 in Bangalore?',
    answer: 'Yes, Aaryan Travels offers round-the-clock wedding luxury cab rental services in Bangalore to suit your wedding schedule.',
  },
  {
    question: 'Are hygiene and safety protocols followed for wedding luxury cab rentals?',
    answer: 'All vehicles are thoroughly sanitized, and drivers adhere to strict safety and hygiene standards for your peace of mind.',
  },
  {
    question: 'What payment options are accepted for wedding luxury cab rentals in Bangalore?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate accounts for wedding luxury cab rentals.',
  },
  {
    question: 'Is customer support available during the wedding luxury cab rental period in Bangalore?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your wedding luxury cab rental experience.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ravi Kumar',
    feedback: 'Aaryan Travels made our wedding luxury cab rentals in Bangalore truly special with excellent cars and drivers.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Mehta',
    feedback: 'Highly recommend Aaryan Travels for wedding luxury cab rentals in Bangalore. Professional and reliable service throughout.',
    rating: 5,
  },
];


























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const weddingLuxuryCabBangaloreSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Wedding Luxury Cab Rentals in Bangalore",
  "description": "Aaryan Travels offers premium wedding luxury cab rentals in Bangalore including chauffeur-driven wedding vehicles, bridal cab hire, luxury SUVs and sedans, executive wedding transport, and more.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Bangalore"
  },
  "serviceType": "Wedding Luxury Cab Rental Service",
  "keywords": "Wedding Luxury Cab Rentals in Bangalore, Bridal Cab Hire Bangalore, Luxury Wedding Car Bangalore, Chauffeur Driven Wedding Vehicle Bangalore, Premium Wedding Taxi Bangalore, Classic Car for Wedding Bangalore, Executive Wedding Transport Bangalore, Affordable Wedding Cab Bangalore, Wedding SUV/Sedan Rental Bangalore, Elite Wedding Cab Bangalore, High-End Wedding Car Bangalore, Best Wedding Chauffeur Bangalore, Wedding Event Cab Bangalore, Bangalore Wedding Car Booking, Prestige Wedding Cabs Bangalore"
};






  return (
    <div>

<Helmet>
  <title>Wedding Luxury Cab Rentals in Bangalore | Bridal & Executive Wedding Cars | Aaryan Travels</title>
  <meta
    name="description"
    content="Book premium wedding luxury cabs in Bangalore with Aaryan Travels. Chauffeur-driven bridal cabs, luxury SUVs and sedans, executive wedding transport, and more."
  />
  <meta
    name="keywords"
    content="Wedding Luxury Cab Rentals in Bangalore, Bridal Cab Hire Bangalore, Luxury Wedding Car Bangalore, Chauffeur Driven Wedding Vehicle Bangalore, Premium Wedding Taxi Bangalore, Classic Car for Wedding Bangalore, Executive Wedding Transport Bangalore, Affordable Wedding Cab Bangalore, Wedding SUV/Sedan Rental Bangalore, Elite Wedding Cab Bangalore, High-End Wedding Car Bangalore, Best Wedding Chauffeur Bangalore, Wedding Event Cab Bangalore, Bangalore Wedding Car Booking, Prestige Wedding Cabs Bangalore"
  />
  <script type="application/ld+json">
    {JSON.stringify(weddingLuxuryCabBangaloreSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/92.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Weddingluxurycabrentals;